import React from 'react';
import _ from 'lodash';
import {
  ListItem,
  Select,
  FormControl,
  OutlinedInput
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  formControl: {
    display: 'flex'
  }
});

const AgentTypeSelector = ({
  options, agentValue, classes, onAgentChange, selectStyles
}) => (
  <FormControl variant="filled" className={classes.formControl}>
    <Select
      variant="filled"
      name="agentType"
      value={agentValue}
      display="flex"
      alignItems="center"
      onChange={onAgentChange}
      input={<OutlinedInput name="agentType" id="outlined-agent-simple" />}
      style={selectStyles}
    >
      {options.map((opt, index) => (
        <ListItem
          button
          key={_.uniqueId('study_agents_agenttype_sel')}
          data-label={opt.label}
          value={opt.value}
        >
          {opt.label}
        </ListItem>
      ))}
    </Select>
  </FormControl>
);

const AgentSelector = withStyles(styles)(AgentTypeSelector);
export { AgentSelector };
